module.exports = __webpack_public_path__ + "img/view.9aebdd67.svg";